export enum ContractStatusEnum {
  None = 0,
  All = 1,
  Active = 2,
  Passive = 3,
}

export const ContractStatusChoices = [
  { value: ContractStatusEnum.All, description: "ALL" },
  { value: ContractStatusEnum.Active, description: "ACTIVE" },
  { value: ContractStatusEnum.Passive, description: "PASSIVE" },
];
